; (function (inovestor, undefined) {
    // Setup dependencies for this plugin
    // Normally we would add jQuery and knockout but ms-core, which we depend on, already register them so it's useless

    // Create plugin namespace with any desired config variable
    inovestor.ms.etf = inovestor.ms.etf || {};
})(inovestor);


; (function (etf, undefined) {
    // Create plugin namespace with any desired config variable
    etf.news = {
        config: {            
            listApiRelativeUrl: 'etfs/news?symbol={symbol}&languageCode={language}',
            detailsApiRelativeUrl: 'etfs/news/{id}'
        }
    };

})(inovestor.ms.etf);
; (function ($, ko, inovestor, undefined) {
    inovestor.ms.etf.news.viewModels = {};

    inovestor.ms.etf.news.viewModels.newsViewModel = function (plugin) {
        var self = this

        self.isLoading = ko.observable(true)
        self.hasError = ko.observable(false)
        self.apiData = ko.observable()

        self.detailsIsLoading = ko.observable(false)
        self.detailsHasError = ko.observable(false)
        self.detailsApiData = ko.observable()

        self.detailsCache = new Map()

        self.pagination = inovestor.ms.etf.news.composables.usePaginations({
            dataSource: ko.pureComputed(function () {
                var apiData = self.apiData()
                return apiData == null ? [] : apiData
            })
        })

        self.init = function () {
            var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } }
            var url = inovestor.ms.core.stringFormat(inovestor.ms.etf.news.config.listApiRelativeUrl, { symbol: plugin.options.symbol, language: inovestor.ms.core.currentLanguage })
            return inovestor.ms.core.ajaxApi(url, options).then(function (data) {
                self.apiData(data.map(function (x) {
                    return $.extend(x, {
                        date: x.date == null ? null: moment(x.date).toDate()
                    })
                }));
            }).fail(function (e) {
                console.error(e);
                self.hasError(true);
            }).always(function () {
                self.isLoading(false);
            })
        }

        self.groupedData = ko.pureComputed(function () {
            var data = self.pagination.pageItems()

            return data.reduce(function (agg, x) {
                var dateKey = x.date == null ? '-' : moment(x.date).format('YYYY-MM-DD')

                var existingDateIndex = agg.findIndex(function (y) { return y.dateKey == dateKey })

                if (existingDateIndex === -1) {
                    agg.push({
                        dateKey: dateKey,
                        items: [x]
                    })
                } else {
                    agg[existingDateIndex].items.push(x)
                }

                return agg
            }, [])
        })

        self.handleNewsClick = function (data) {
            self.detailsApiData(undefined)
            self.detailsHasError(false)
            self.detailsIsLoading(true)

            $('#NewsDetailModal').modal('show')

            var url = inovestor.ms.core.stringFormat(inovestor.ms.etf.news.config.detailsApiRelativeUrl, { id: data.id })

            if (!self.detailsCache.has(url)) {
                var options = { type: 'GET', contentType: 'application/json', error: function (error) { plugin.apiErrorHandler(error); } }
                inovestor.ms.core.ajaxApi(url, options).then(function (data) {
                    var mappedData = $.extend(data, {
                        date: data.date == null ? null: moment(data.date).toDate()
                    })

                    self.detailsCache.set(url, mappedData)

                    self.detailsApiData(mappedData)
                }).fail(function (e) {
                    console.error(e)
                    self.detailsHasError(true)
                }).always(function () {
                    self.detailsIsLoading(false)
                })
            } else {
                self.detailsApiData(self.detailsCache.get(url))
                self.detailsIsLoading(false)
            }
        }

        // Improve accessiblity of bootstrap modals

        setTimeout(function () {
            var focusBeforeOpeningModal
            $('.ino-ms-etf-news__modals').on('show.bs.modal', function () {
                focusBeforeOpeningModal = document.activeElement
            })
            $('.ino-ms-etf-news__modals').on('hidden.bs.modal', function () {
                if (focusBeforeOpeningModal != null && focusBeforeOpeningModal instanceof HTMLElement) {
                    focusBeforeOpeningModal.focus()
                }
            })
            $('.ino-ms-etf-news__modals').on('shown.bs.modal', '.modal', function() {
                $(this).find('[autofocus]').focus() 
                $(this).find('.modal-body').scrollTop(0)
            })
        })

        // Base stuff

        self.language = ko.observable(inovestor.ms.core.currentLanguage)
        self.resources = ko.observable()
        self.updateResources = function () {
            // Update main resources
            var currentResource = inovestor.ms.etf.news.resources[inovestor.ms.core.currentLanguage]
            if (inovestor.ms.core.isNullOrUndefined(currentResource))
                currentResource = null
            self.resources(currentResource)
            self.language(inovestor.ms.core.currentLanguage)
        }
    }

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {

    var pluginName = 'inoMsEtfNews';

    // Create the plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this._name = pluginName;
        this._defaults = $.fn.inoMsEtfNews.defaults;

        // Merge options with defaults
        this.options = $.extend({}, this._defaults, options);

        if (inovestor.ms.core.isEmptyString(this.options.symbol)) throw new Error('Symbol is required for ' + pluginName + ' plugin');

        this._viewModel = new inovestor.ms.etf.news.viewModels.newsViewModel(this);

        // Call init
        this.init();
    }

    $.extend(Plugin.prototype, {

        // Initialization logic
        init: function () {
            var plugin = this;

            // Setup what plugin needs to do on language change
            inovestor.ms.core.instances.register(this, function () {
                plugin._viewModel.updateResources();
            });

            // Plugin overrides for template = cacheKey and path are the same
            var fileCacheKey = plugin.options.templatePaths.news;
            var filePath = plugin.options.templatePaths.news;
            // Default behavior (if no template path is set by plugin)
            if (inovestor.ms.core.isEmptyString(fileCacheKey)) {
                var fileName = 'news.html';
                fileCacheKey = pluginName + '.' + fileName;
                filePath = (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) ? '' : inovestor.ms.core.config.templateRootUrl) +
                    (inovestor.ms.core.isEmptyString(inovestor.ms.core.config.templateRootUrl) || inovestor.ms.core.config.templateRootUrl.match(/\/$/) != null ? '' : '/') + // check if templateRootUrl ends in slash
                    (this._name + '/' + fileName);
            }

            // Get main template file
            inovestor.ms.core.getTemplate(fileCacheKey, filePath).then(function (template) {
                $(plugin.element).html(template);
                plugin.buildCache();
                plugin.bindEvents();
                plugin.bindModel();
                plugin.render();
            }).then(function () {
                plugin._viewModel.init().always(function () {
                    plugin.$element.trigger('ready' + '.' + plugin._name);
                });
            });
        },

        // Remove plugin instance completely
        destroy: function () {
            this.unbindEvents();
            this.$element.removeData();
        },

        // Cache DOM nodes for performance
        buildCache: function () {
            this.$element = $(this.element);
        },

        // Bind events that trigger methods
        bindEvents: function () {
            var plugin = this;
            plugin.$element.on('ready' + '.' + plugin._name, function () {
                var onReady = plugin.options.onReady;
                if (typeof onReady === 'function')
                    onReady.call(plugin.$element);
            });
        },

        // Unbind events that trigger methods
        unbindEvents: function () {
            this.$element.off('.' + this._name);
        },

        // API error handler
        apiErrorHandler: function (apiError) {
            var plugin = this;
            var onError = plugin.options.onError;
            if (typeof onError === 'function') {
                var result = onError.call(inovestor.ms.core.generateError(inovestor.ms.core.errors.apiError, apiError, plugin));
                // If callback returns false, do not execute default behavior
                if (!inovestor.ms.core.isNullOrUndefined(result) && result === false)
                    return;
            }
        },

        // Renders html template and binds model (should be called once)
        render: function () {
            var plugin = this;
            plugin._viewModel.updateResources();
        },

        // Applies knockout bindings to element. (Should be done only once)
        bindModel: function () {
            var plugin = this;
            ko.applyBindings(plugin._viewModel, plugin.element);
        }
    });

    // JQuery Plugin wrapper
    $.fn.inoMsEtfNews = function (options) {
        this.each(function () {
            if (!$.data(this, pluginName)) {
                // Store instance of plugin in "$.data"
                $.data(this, pluginName, new Plugin(this, options));
            }
        });

        // return plugin to support JQuery chaining
        return this;
    };

    // Default options for plugin
    $.fn.inoMsEtfNews.defaults = {
        symbol: null,
        onError: null,
        onReady: null,
        templatePaths: {
            news: null
        }
    };

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {
    inovestor.ms.etf.news.composables = inovestor.ms.etf.news.composables || {}

    inovestor.ms.etf.news.composables.usePaginations = function (options) {
        var resources = inovestor.ms.etf.news.composables.useResources()

        var pageSize = ko.observable(10)
        var currentPage = ko.observable(1)
        var start = ko.pureComputed(function () { return (currentPage() -1) * pageSize() + 1 })
        var end = ko.pureComputed(function () { return start() + pageItems().length - 1 })
        var total = ko.pureComputed(function () { return options.dataSource().length })

        var pageItems = ko.pureComputed(function () {
            var startIndex = (currentPage() - 1) * pageSize()
            return options.dataSource().slice(startIndex, startIndex + pageSize())
        })

        function setupPaginationPlugin () {
            var nb = total()

            if (nb > 0) {
                currentPage(1)

                var resultsPerPage = pageSize()
                var numPages = nb / resultsPerPage
                if (nb % resultsPerPage > 0) {
                    numPages++
                }

                // Destroy old instance of the plugin than recreate
                const $pagination = $('.ino-ms-etf-news-pagination')
                $pagination.twbsPagination('destroy')
                $pagination.twbsPagination({
                    totalPages: numPages,
                    visiblePages: 5,
                    initiateStartPageClick: false,
                    startPage: currentPage(),
                    first: resources().pagination.firstPage,
                    prev: resources().pagination.previousPage,
                    next: resources().pagination.nextPage,
                    last: resources().pagination.lastPage,
                    onPageClick: (event, page) => {
                        currentPage(page)
                    }
                })
            }
        }

        setupPaginationPlugin()
        resources.subscribe(setupPaginationPlugin)
        pageSize.subscribe(setupPaginationPlugin)
        options.dataSource.subscribe(function () {
            setTimeout(setupPaginationPlugin)
        })

        return {
            pageSize: pageSize,
            currentPage: currentPage,
            start: start,
            end: end,
            total: total,
            pageItems: pageItems
        }
    }
})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function ($, ko, inovestor, undefined) {
    inovestor.ms.etf.news.composables = inovestor.ms.etf.news.composables || {}

    inovestor.ms.etf.news.composables.useResources = function () {
        return ko.pureComputed(function () {
            return inovestor.ms.ko.currentLanguage() === 'fr' ? inovestor.ms.etf.news.resources['fr'] : inovestor.ms.etf.news.resources['en']
        })
    }
})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
/*
The goad of the custom element is to shield the style of the news details by using a shadow DOM.
So all style from the host page (light DOM) will not affect the news details.
And, all styles from the news details will not affect the host page.
*/

; (function ($, ko, inovestor, undefined) {
    customElements.define('ino-ms-etf-news-details', class NewsDetailsElement extends HTMLElement {
        static observedAttributes = ['news-body', 'news-style']

        constructor () {
            super()
            this.attachShadow({ mode: 'open' })
        }

        connectedCallback() {
            this._render()
        }

        attributeChangedCallback() {
            this._render()
        }

        _renderDebounceHandle = undefined

        _render () {
            clearTimeout(this._renderDebounceHandle)

            this._renderDebounceHandle = this._renderDebounceHandle = setTimeout(() => {
                var children = []

                if (!inovestor.ms.core.isEmptyString(this.getAttribute('news-style'))) {
                    var styleElement = document.createElement('style')
                    styleElement.innerHTML = this.getAttribute('news-style')
                    children.push(styleElement)
                }

                if (!inovestor.ms.core.isEmptyString(this.getAttribute('news-body'))) {
                    var bodyElement = document.createElement('div')
                    bodyElement.innerHTML = this.getAttribute('news-body')
                    children.push(bodyElement)
                }

                this.shadowRoot.innerHTML = ''
                children.forEach(x => this.shadowRoot.appendChild(x))
            })
        }
    })

})(inovestor.ms.libRef.jQuery, inovestor.ms.libRef.ko, inovestor);
; (function (etf, undefined) {
    etf.news.resources = etf.news.resources || {};
    etf.news.resources["en"] = {
        noNews: 'There is no news',
        close: 'Close',
        pagination: {
            paginationInfo: '{start} - {end} of {total}',
            nextPage: 'Next',
            previousPage: 'Previous',
            firstPage: 'First',
            lastPage: 'Last',
            itemsPerPage: 'Rows per page'
        }
    };
})(inovestor.ms.etf);

; (function (etf, undefined) {
    etf.news.resources = etf.news.resources || {};
    etf.news.resources["fr"] = {
        noNews: "Il n'y a pas de nouvelle",
        close: 'Fermer',
        pagination: {
            paginationInfo: '{start} à {end} de {total}',
            nextPage: 'Prochain',
            previousPage: 'Précédent',
            firstPage: 'Premier',
            lastPage: 'Dernier',
            itemsPerPage: 'Items par page'
        }
    };
})(inovestor.ms.etf);
